export default __webpack_public_path__ + "static/media/BLAZE-Logo-Flat-Black.9d04bfb5.svg";